/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {style: {alignItems: 'baseline'}},
        label: {
            width: 'full'
        },
        control: {
            width: '18px',
            height: '18px',
            flexShrink: 0,
            borderRadius: 0,
            marginTop: '2px',
            borderColor: 'black',
            _checked: {
                backgroundColor: 'black',
                borderColor: 'black',
                _hover: {
                    opacity: '0.9',
                    bg: 'black',
                    borderColor: 'black'
                }
            }
        }
    },
    sizes: {
        md: {
            label: {fontSize: 'sm'}
        }
    },
    variants: {
        filters: {
            control: {
                borderWidth: '1px'
            }
        }
    }
}
